import { useEffect, useState } from 'react';
import { Bell, BellOff, BellRing } from 'lucide-react';
import { pushSupported, getPushStatus, subscribeToPush, unsubscribeFromPush } from '../lib/push';

export default function NotifyButton() {
  const [status, setStatus] = useState('idle'); // idle | subscribed | denied | unsupported | working
  const [msg, setMsg] = useState('');

  useEffect(() => { getPushStatus().then(setStatus); }, []);

  const handleClick = async () => {
    setMsg('');
    if (status === 'subscribed') {
      setStatus('working');
      try { await unsubscribeFromPush(); setStatus('idle'); }
      catch (e) { setMsg(e.message); setStatus('subscribed'); }
      return;
    }
    if (!pushSupported()) { setMsg('Not supported on this browser'); return; }
    setStatus('working');
    try {
      await subscribeToPush();
      setStatus('subscribed');
      setMsg("you're in. i'll ping when i update.");
      setTimeout(() => setMsg(''), 4000);
    } catch (e) {
      setMsg(e.message);
      setStatus(Notification.permission === 'denied' ? 'denied' : 'idle');
    }
  };

  const cfg = {
    idle:        { icon: Bell,     text: 'notify me when updated', cls: 'border-primary/30 bg-primary/5 text-primary hover:bg-primary/20' },
    working:     { icon: Bell,     text: 'just a sec…',            cls: 'border-primary/30 bg-primary/5 text-primary opacity-60' },
    subscribed:  { icon: BellRing, text: 'subscribed · click to stop', cls: 'border-emerald-500/30 bg-emerald-500/5 text-emerald-400 hover:bg-emerald-500/15' },
    denied:      { icon: BellOff,  text: 'blocked in browser settings', cls: 'border-rose-500/30 bg-rose-500/5 text-rose-400 cursor-not-allowed' },
    unsupported: { icon: BellOff,  text: 'not supported here',     cls: 'border-border bg-secondary/40 text-muted-foreground cursor-not-allowed' },
  }[status] || { icon: Bell, text: 'notify me when updated', cls: '' };

  const Icon = cfg.icon;
  const disabled = status === 'working' || status === 'denied' || status === 'unsupported';

  return (
    <div className="mt-4 flex flex-col gap-1.5">
      <button
        onClick={handleClick}
        disabled={disabled}
        data-testid="islamic-notify-btn"
        className={`inline-flex items-center gap-2 self-start font-mono-cv text-[10px] tracking-wider uppercase border px-3 py-1.5 rounded-full transition-all ${cfg.cls}`}
      >
        <Icon size={11} /> {cfg.text}
      </button>
      {msg && <p className="text-[10px] text-muted-foreground italic">{msg}</p>}
    </div>
  );
}
